import React, { useEffect, useRef, useState } from 'react'
import { firestore } from '../../../../../firebase'
import { sortArray } from '../../../../../helpers/arraySorter'
import ScoreBoard from './ScoreBoard'
import SinglePlayerRound from './SinglePlayerRound'

function PlayerPointsRound({roundId, hostcupId, roundData}) {

    const [players, setPlayers] = useState([])
    const [results, setResults] = useState([])
    const [teams, setTeams] = useState([]);
    const [scores, setScores] = useState([])

    const scoreBoard = useRef(null)

    useEffect(() => {
        if (hostcupId && roundId) {
            console.log(hostcupId, "HostcupId")
            console.log(roundId, "Round ID")
            try {
                const playersRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("players");
                playersRef.onSnapshot(({docs}) => {
                    const players = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    });

                    const sortedPlayers = sortArray(players, "name")
                    console.log(sortedPlayers)
                    setPlayers(players);
                })
            } catch (error) {
                console.log(error)
            }
        }


    }, [roundId, hostcupId])

    useEffect(() => {

        const resultsRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("results");
        resultsRef.onSnapshot(({docs}) => {
            const results = docs.map(doc => {
                return {id: doc.id, ...doc.data()}
            });
            setResults(results);
        })

    }, [roundId, hostcupId])


    useEffect(() => {

        const teamsRoundRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("teams");
        teamsRoundRef.orderBy("draw").onSnapshot(({docs}) => {
            const teams = docs.map(doc => {
                return {id: doc.id, ...doc.data()}
            });
            setTeams(teams);
            console.log("TEAMS: ", teams)
        })

    }, [roundId, hostcupId])

    function scrollToRef(ref) {
        window.scrollTo(0, ref.current.offsetTop)
    }

    return (
    <React.Fragment>{teams.length && results.length ? (
        <div>
            <h4 className="my-2">Lagre resultater (trykk på +)</h4>
            <button className="btn btn-sm btn-primary my-3" onClick={() => scrollToRef(scoreBoard)}>Til resultater</button>
            {players?.map((player, index) => {
                return (
                <SinglePlayerRound 
                    key={index} 
                    player={player} 
                    results={results} 
                    teams={teams}  
                    roundId={roundId}
                    hostcupId={hostcupId}   
                    scores={scores}
                    roundData={roundData}
                />)
            })}
            <hr />
            <h4 ref={scoreBoard} className="my-5">Resultatliste</h4>
            <ScoreBoard 
                roundId={roundId} 
                hostcupId={hostcupId} 
                scores={scores}
                setScores={setScores}
            />
        </div>
    ) : "Kunne ikke finne lag eller resultater"}</React.Fragment>

    )
}
export default PlayerPointsRound